import { useI18n } from "@/i18n/I18nContext";

/** Small reassurance badge displayed near any payment / pre-registration CTA.
 *  Sober medieval theme — parchment background + small lock icon. */
export default function SumUpBadge({ variant = "default" }) {
  const { locale } = useI18n();
  const lockColor = "var(--cinnabar)";
  const isCompact = variant === "compact";
  return (
    <div
      data-testid="sumup-badge"
      className={`inline-flex items-center gap-2 ${isCompact ? "px-2.5 py-1.5" : "px-3 py-2"}`}
      style={{
        background: "rgba(245,240,228,0.9)",
        border: "1px solid rgba(20,16,12,0.18)",
        borderRadius: "2px",
        backdropFilter: "blur(2px)",
      }}
    >
      <svg width={isCompact ? 12 : 14} height={isCompact ? 12 : 14} viewBox="0 0 24 24" fill="none"
           stroke={lockColor} strokeWidth="1.6" aria-hidden="true">
        <rect x="5" y="11" width="14" height="9" rx="1.5" />
        <path d="M8 11V8a4 4 0 1 1 8 0v3" strokeLinecap="round" />
      </svg>
      <span
        className="font-caps"
        style={{
          fontSize: isCompact ? "0.55rem" : "0.6rem",
          letterSpacing: "0.22em",
          color: "var(--ink)",
          whiteSpace: "nowrap",
        }}
      >
        {locale === "fr" ? "Paiement sécurisé · SumUp" : "Secure payment · SumUp"}
      </span>
    </div>
  );
}
